export default __webpack_public_path__ + "static/media/1032.47d4cde7.svg";